<template>
  <div class="subtopic-container">
    <div class="header" v-on:click="openToggle">
      <h4>{{lang == 'ar' ? data.subtopic_AR : data.subtopic_EN}}</h4>
      <div class="caret"  v-bind:class="{ up: isOpen }"></div>
    </div>
    <transition name="slide">
      <div v-if="isOpen" class="subtopic-content">
        <img class="image-subcat" v-if="data.image_link != ''" v-bind:src="data.image_link"/>
        <div class="paragraph" v-html="textBlock"></div>
        <div class="advice" v-if="advice">{{advice}}</div>
        <div class="stats" v-if="stats" v-html="stats"></div>
      </div>
    </transition>
  </div>
</template>

<script>
  import textFormat from '@/utils/textFormat'
  
  export default {
    name: "subtopic-component",
    props: ['data'],
    data(){
      return{
        isOpen : false,
      }
    },
    computed: {
      lang () {
        return this.$i18n.locale
      },
      textBlock() {
        let blocks = []
        
        let text = this.lang == 'ar' ? this.data.paragraph_AR : this.data.paragraph_EN
        blocks = textFormat.formatParagraphs(text)

        return blocks
      },
      advice () {
        return this.lang == 'ar' ? this.data.advices_CR_AR : this.data.advices_CR_EN
      },
      stats() {
        var styleVar = {
          'color': '#63EAAD',
          'display': 'inline-block',
          'width': '100%',
          'text-align': 'center',
          'font-size': '50px'
        }
        let stats = this.lang == 'ar' ? this.data.stats_AR : this.data.stats
        if (stats) {
          var chunks = stats.split("*")
          if (chunks.length == 3)
            stats = chunks[0] + "<div class='data-value' style='color: #63eaad; font-size: 40px; font-weight: bold'>" + chunks[1] + "</div>" + chunks[2]
          stats = stats.split('\\').join('<br/>')
          return stats
        }
        return ''
      }
    },
    methods: {
      openToggle() {
        this.isOpen = !this.isOpen
      }
    }
  }
</script>

<style lang="stylus" scoped>
.subtopic-container
  text-align left 
  min-height: 90px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3px 6px #cdcdcd;
  color: #707070;
  width: 90%;
  margin-left: 5%;
  margin-bottom 20px;
  display flex
  flex-direction column
  transition: height 2s;

  .header
    font-size: 15px;
    margin 0 15px;
    display flex
    flex-direction row
    min-height: 90px;
    align-items center
    h4
      display: flex;
    .caret
      background: url('~@/../static/icons/chevron-down.svg') no-repeat center center;
      background-size: 20px;
      width: 20px;
      height: 20px;
      margin-left auto
      transition 0.25s
    .caret.up
      transform rotate(-180deg) translateY(-6px)


  .subtopic-content
    margin: 20px;
    text-align: left;
    color: #707070;

  .paragraph
    margin-bottom: 10px;
    font-size:20px;

  
  .advice
    margin-bottom: 15px;
    font-size: 18px;
    text-align: center;
    padding-bottom: 30px;

  .advice:before
    border-top: 1px solid #ccc;
    padding-top: 30px;
    content: '"';
    color: #63EAAD;
    font-size: 38px;
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-top: 15px;

  .stats
    padding-top: 30px;
    border-top: 1px solid #ccc;
    margin-top: 15px;
    text-align: center;
    font-size: 14px

  .data-value
    color: #63EAAD;
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: 50px;

  

  .image-subcat
    width: 50%;
    margin-left: 25%;
    margin-top: -30px;

.ar
  .subtopic-container
    .header
      flex-direction row-reverse
    .caret
      margin-left 5px
      margin-right auto
  ul
    direction rtl
  .paragraph
    text-align right 

</style>



// WEBPACK FOOTER //
// src/components/SubtopicComponent.vue